import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';

/**
 * AnyGift properties 移動コンポーネント
 *
 * @element kd-any-gift-properties
 * @description AnyGiftモーダルクローズ時にプロパティが消えるのを防ぐため、
 *              hidden input (properties[*]) を body 配下にコピーする。
 */
@customElement('kd-any-gift-properties')
export class KdAnyGiftProperties extends LitElement {
  createRenderRoot() {
    return this;
  }

  private handleClick = (event: Event): void => {
    const button = event.target as HTMLButtonElement;
    if (button?.name !== 'add') return;

    const propertiesInputs = document.querySelectorAll(
      SELECTORS.ANY_GIFT.PROPERTIES_INPUTS
    );
    propertiesInputs.forEach((input) => {
      document.body.appendChild(input);
    });
  };

  connectedCallback(): void {
    super.connectedCallback();
    const body = document.getElementById('body');
    if (body) {
      body.addEventListener('click', this.handleClick);
    }
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    const body = document.getElementById('body');
    if (body) {
      body.removeEventListener('click', this.handleClick);
    }
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-any-gift-properties': KdAnyGiftProperties;
  }
}
